function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".tag{fill:#ee3f5c;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "tag",
  d: "M12.327,5.139v0a7.706,7.706,0,0,0-7.686,7.686V40.322a7.653,7.653,0,0,0,7.686,7.612H23.745l6.818,8.153a1.183,1.183,0,0,0,1.811,0l6.887-8.157H50.684a7.653,7.653,0,0,0,7.686-7.612V12.825a7.706,7.706,0,0,0-7.686-7.686Zm0,2.37H50.684A5.307,5.307,0,0,1,56,12.829V40.322a5.234,5.234,0,0,1-5.321,5.247H38.711a1.183,1.183,0,0,0-.905.42l-6.333,7.5L25.2,45.994a1.183,1.183,0,0,0-.905-.425H12.327a5.234,5.234,0,0,1-5.321-5.247V12.829A5.307,5.307,0,0,1,12.327,7.508Zm19.326,5.538a14.109,14.109,0,1,0,14.07,14.107A14.106,14.106,0,0,0,31.653,13.047Zm0,2.365a11.744,11.744,0,1,1-11.7,11.742A11.705,11.705,0,0,1,31.653,15.411Zm-4.1,6.462a1.183,1.183,0,0,0-.822,2.032l3.247,3.252-3.247,3.247a1.182,1.182,0,1,0,1.672,1.672l3.247-3.247L34.9,32.077A1.182,1.182,0,1,0,36.572,30.4l-3.247-3.247,3.247-3.252A1.182,1.182,0,1,0,34.9,22.234l-3.247,3.247-3.247-3.247A1.183,1.183,0,0,0,27.556,21.874Z",
  transform: "translate(-4.641 -5.139)"
});

function SvgTag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.729,
    height: 51.37,
    viewBox: "0 0 53.729 51.37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/Tag.38af9340.svg";
export { ForwardRef as ReactComponent };